import { render, staticRenderFns } from "./evolution.vue?vue&type=template&id=94fb9634&scoped=true"
import script from "./evolution.vue?vue&type=script&lang=js"
export * from "./evolution.vue?vue&type=script&lang=js"
import style0 from "./evolution.vue?vue&type=style&index=0&id=94fb9634&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fb9634",
  null
  
)

export default component.exports